angular.module("app").controller("LogoutController", [
    '$scope',
    function ($scope) {
        $scope.logout = function () {
          window.localStorage.removeItem("t");
          window.location.href = "/user/logout";
        }
    }
])